import React from 'react';
import { getTranslatedKPINameV2, getTranslateSignalDescription, translate } from 'helpers/translateHelper';
import { getMeasurementUnitSymbol } from 'helpers/unitHelper';
import { convertToCustomLocaleDate, formatTime } from 'helpers/dateTimeFormatter';

export const getAnomalyOverallLevel = (selectedAsset) => (kpiKey) => {
    const kpis = selectedAsset?.trend?.KPIs;
    if (!kpis?.length) { return 0; }
    const kpi = kpiKey
        ? kpis.find(k => k?.key === kpiKey)
        : kpis.find(k => k?.isAnomaly);
    return kpi?.anomalyLevel ?? 0;
};

export const getColumns = () => [
    {
        title: translate('ABB.Powertrain.Frontend.signalLabel'),
        dataIndex: 'signal',
        key: 'signal',
        width: 300,
        render: (signal, record) => {
            return (
                <div className='relevant-signal-label'>
                    <span className='relevant-signal-name'>{signal}</span>
                    {record?.unit &&
                        <span className='relevant-signal-unit'>{getMeasurementUnitSymbol(record?.unitGroupId)}</span>
                    }
                </div>
            );
        }
    },
    {
        title: translate('ABB.Powertrain.Frontend.signalDescriptionLabel'),
        dataIndex: 'description',
        key: 'description',
        width: 350
    }
];

export const getTableData = (coolingAnomalyKPI) => {
    const tableData = [
        {
            key: 'cooling-anomaly',
            signal: translate('ABB.Powertrain.Frontend.coolingAnomalyChartLegend'),
            unit: '',
            unitGroupId: null,
            description: translate('ABB.Powertrain.Frontend.coolingAnomalyDescription')
        }
    ];
    const signalRows = coolingAnomalyKPI?.conditionTrends
        ?.filter(trend => trend.type !== 'Kpi')
        .map((trend, index) => ({
            key: trend?.key || `signal-${index}`,
            signal: getTranslatedKPINameV2(trend),
            unit: trend?.unit || '',
            unitGroupId: trend?.unitGroupId || null,
            description: getTranslateSignalDescription(trend)
        })) || [];
    return [...tableData, ...signalRows];
};

export const getXAxisLabelDateFormatForDriveAnomaly = (tickValue) => {
    const isDayBoundary = tickValue && new Date(tickValue).getHours() === 0 && new Date(tickValue).getMinutes() === 0;
    const options = { day: 'numeric', month: 'numeric' };
    return isDayBoundary ? convertToCustomLocaleDate(tickValue, options)
        : formatTime(tickValue, { timeStyle: 'short' });
};
